<script>
import { authComputed } from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import store from "../state/store";

export default {
  components: { VuePerfectScrollbar },
  props: {
    isMenuOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
    user () {
      return this.$store.state.user
    },
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
  },
  created () {
    if (store.getters['auth/loggedIn']) {
      this.$store.dispatch('getLoginUser')
    }
  },
}
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <div class="container-fluid">
      <ul class="list-unstyled topnav-menu float-right mb-0">
<!--        for menu hide and show in mobile view-->
        <li class="dropdown notification-list">
          <a
            class="navbar-toggle nav-link"
            :class="{ 'open': isMenuOpened }"
            @click="toggleMenu"
          >
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
        </li>

        <b-nav-item-dropdown
          right
          class="notification-list"
          menu-class="profile-dropdown"
        >
          <template slot="button-content">
            <div class="nav-user mr-0">
              <img src="@assets/images/railway.png" alt="user-image" class="rounded-circle"/>
              <span class="pro-user-name ml-1">
                {{user ? user.name : ''}}
                <i class="mdi mdi-chevron-down"></i>
              </span>
            </div>
          </template>

          <b-dropdown-item href="/user/profile">
            <i class="fe-user mr-1"></i>
            <span>My Account</span>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/logout">
            <i class="fe-log-out mr-1"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>

      </ul>

      <!-- LOGO -->
      <div class="logo-box">
        <a href="/" class="logo text-center">
          <span class="logo-lg">
            <img src="@assets/images/padma.png" alt height="40" />
          </span>
          <span class="logo-sm">
            <img src="@assets/images/railway.png" alt height="24"  />
          </span>
        </a>
      </div>

<!--      <ul class="list-unstyled topnav-menu topnav-menu-left m-0">-->
<!--        <b-nav-item-dropdown class="d-none d-lg-block" right>-->
<!--          <template slot="button-content">-->
<!--            Create New-->
<!--            <i class="mdi mdi-chevron-down"></i>-->
<!--          </template>-->
<!--          <b-dropdown-item href="#">-->
<!--            <i class="fe-briefcase mr-1"></i>-->
<!--            <span>New Projects</span>-->
<!--          </b-dropdown-item>-->
<!--        </b-nav-item-dropdown>-->
<!--      </ul>-->
    </div>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
